import { Box, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { ExtendedRuleDefinition } from '../../gen/api/api';
import useRuleComponents from './RuleComponentHooks';

const { renderFields } = useRuleComponents();

interface AdditionalProps {
    readonly ruleDefinition: ExtendedRuleDefinition;
    readonly width: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;
    readonly disabled: boolean;
}

type DefaultRuleComponentProps = AdditionalProps;

const DefaultRuleComponent: React.FunctionComponent<DefaultRuleComponentProps> = (props) => {
    return (
        <Grid item xs={props.width} key={props.ruleDefinition.ruleCode}>
            <Box p={1} m={1} boxShadow={3}>
                <Typography>{props.ruleDefinition.ruleName}</Typography>
                <Grid container spacing={1}>
                    {renderFields(
                        props.ruleDefinition,
                        Object.values(props.ruleDefinition.factDefinitions),
                        '',
                        props.disabled,
                    )}
                </Grid>
            </Box>
        </Grid>
    );
};

export default DefaultRuleComponent;
